module.exports = __webpack_public_path__ + "img/20190606111035770.a749ef8c.png";